import { render, staticRenderFns } from "./sexmetkerst.vue?vue&type=template&id=7ffaf553"
import script from "./sexmetkerst.vue?vue&type=script&lang=js"
export * from "./sexmetkerst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports